export default __webpack_public_path__ + "static/char-s-49-en-109fb57a1705bc57218c1b29b0655aa7.webp";